"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function buildIncludePathsFactory(path) {
  return function (nodeSassIncludePaths, previouslyResolvedPath) {
    var includePaths = [];

    if (path.isAbsolute(previouslyResolvedPath)) {
      includePaths.push(path.dirname(previouslyResolvedPath));
    }

    return _toConsumableArray(new Set([].concat(includePaths, _toConsumableArray(nodeSassIncludePaths.split(path.delimiter)))));
  };
}

exports.buildIncludePathsFactory = buildIncludePathsFactory;